module.exports = __webpack_public_path__ + "static/media/J-Hearts.73bc086e.svg";